<template>
  <div>
    <div class="row">
      <div class="col s12 m8 l10 xl10">
        <div class="row">
          <div class="input-field col s12">
            <i class="material-icons prefix ">search</i>
            <input id="search" type="text" class="validate" v-model="filterTerm">
            <label for="search">Pesquisar</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s12 m12 l12 xl12">

        <table>
          <thead>
            <tr>
              <th>
                #
                <a class="left" href="#" @click="toggleOrder($event, 'id')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
                </a>
              </th>
              <th>
                Tipo
                <a class="left" href="#" @click="toggleOrder($event, 'tipo')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyTipo }" >sort</i>
                </a>
              </th>
              <th>
                Mensagem
              </th>
              <th>
                Edit.
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="mensagem in filteredMensagens">
              <td>{{ mensagem.id }}</td>
              <td>{{ mensagem.tipo }}</td>
              <td>{{ mensagem.mensagem }}</td>
              <td>
                <a data-tooltip="Editar uma mensagem" :href="'/mensagems/' + mensagem.id + '/edit'" class="waves-effect waves-light btn-small tooltipped">
                  <i class="material-icons">edit</i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "VueMensagems",
      props: [
        'mensagens'
      ],
      data () {
        return {
          listaMensagens: JSON.parse(this.mensagens),
          sortProperty: 'id',
          sortDirection: 'asc',
          filterTerm: '',
          sortPropertyId: true,
          sortPropertyTipo: false,
        }
      },
      computed: {
        filteredMensagens: function () {
          var self = this
          return _.orderBy(self.listaMensagens.filter(function (mensagem) {
            var searchRegex = new RegExp(self.filterTerm, 'i')
            return (
              searchRegex.test(mensagem.id) ||
              searchRegex.test(mensagem.tipo)
            )
          }), this.sortProperty, this.sortDirection)
        },
      },
      methods: {
        toggleOrder (ev, field) {
          ev.preventDefault()
          if (this.sortProperty == field){
            if (this.sortDirection == 'asc')
              this.sortDirection = 'desc'
            else
              this.sortDirection = 'asc'
          } else {
            this.iconsColor(this.sortProperty, false)
            this.iconsColor(field, true)
            this.sortProperty = field
            this.sortDirection = 'asc'
          }
        },
        iconsColor(field, value){
          switch (field) {
            case 'id':
              this.sortPropertyId = value
              break;
            case 'tipo':
              this.sortPropertyTipo = value
              break;
            default:
          }
        },
      }
    }
</script>
